import styled from 'styled-components';

import Modal from 'react-bootstrap/Modal';

export const ChildrenContainer = styled.div`
    margin: ${props => props.NoMargin ? 0 : '0 7.5%'};
`;

export const StyledModal = styled(Modal)``;